export default __webpack_public_path__ + "static/media/logoHeartRound-192.302a89eb.png";